import React,{useEffect} from 'react'
import { FormInputSelectAndNavigateBranch } from '../../../../../../../ui/organisms'
import { toJS } from 'mobx'
import { useStore } from '../../../../../../../store'

let list = [
    {
      value: 'Sub-contractor',
      next: 'projectInfo.projectTrade2',
    },
    {
      value: 'Sub-contractor & General-contractor',
      next: 'projectInfo.projectTrade2',
    },
    {
      value: 'General Contractor',
      next: 'projectInfo.projectPayingParty',
    },
    {
      value: 'General Contractor/Developer',
      next: 'projectInfo.projectValue',
    },
    {
        value: 'Developer',
        next: 'projectInfo.projectValue',
    },
    {
        value: 'Developer/Property Owner',
        next: 'projectInfo.projectValue',
    },
    {
        value: 'Property Owner',
        next: 'projectInfo.projectValue'
    }
]
  
  export default {
    title: 'What is your role in the project??',
    list,
    component: (props) => {
        const { userStore } = useStore()
        const loanApplication = userStore.document

        const item = props.document.data?.get('projectInfo')?.get('projectType')

        if(['State Construction', 'Federal Construction'].includes(item.content)){
            list = list.filter(item => !['General Contractor/Developer','Developer','Developer/Property Owner', 'Property Owner'].includes(item.value))
        }

        if(loanApplication){
          const role = loanApplication?.data?.get('businessInfo')?.get('describeYourSelf')
  
          if(['Contractor', 'Contractor, Property Owner, and Developer'].includes(role)){
            const subcontractorListItem1 = list.find(listItem => listItem.value === 'Sub-contractor')
            subcontractorListItem1.next = 'projectInfo.projectTrade1'
            const subcontractorListItem2 = list.find(listItem => listItem.value === 'Sub-contractor & General-contractor')
            subcontractorListItem2.next = 'projectInfo.projectTrade1'
          }
        }


        console.log('list', list)
      
        return(
            <FormInputSelectAndNavigateBranch list={list} {...props}/>
        )
    }
  }
  